export const getCountries = async () => {
  return await fetch("https://assets.orbaone.com/api/countries")
    .then(async (response) => {
      const res = await response.json();
      return res;
    })
    .then((data) => data);
};
